import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaLock, FaList, FaChartBar } from 'react-icons/fa';
import { GoEyeClosed } from 'react-icons/go'
import { MdGridView } from "react-icons/md";

export const InfoContainer = styled.div`
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  background-size: 100% auto;
  padding: 0px 0px;
  // width: 50%

  @media screen and (max-width: 450px){
   width: 100%;
  }
`;

export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: flex;
  justify-content: center;
`;



export const FormH1 = styled.h1`
  margin-top: 10px;
  margin-bottom: 10px;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
   @media screen and (max-width: 450px) {
    margin-bottom: 2px;
  }
`

export const HeadingHelpersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 600px;

  
  @media screen and (max-width: 480px) {
    flex-direction: ${({ swap }) => (swap ? 'column' : 'row')};
    width: 300px;
  }
`


export const VStack = styled.div`
  display: flex;
  flex-direction: column;
`


export const ValueWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (min-width: 490px){
    justify-content: center;
  }
`;

export const FormInfoText = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  margin-right:10px;
  color: #010606;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
`;

export const FormInfoValue = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  color: ${({ errorText }) => (errorText ? '#006ee6' : 'red')};
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  text-align: center;
`;


export const SelectButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  justify-self: center;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  }

  
  @media screen and (max-width: 500px){
    margin-top: 0px;
  }
`;

export const ViewSlectionRow = styled.div`
  display: flex;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  margin-top: 6px;

  @media screen and ((max-width: 430px) ) {
    margin-right: 36px;
  margin-left: 40px;
  }
`;

export const RowGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 42px;
`;


export const StyledIconGrid = styled(MdGridView)`
 margin: 14px;
 color:${({ selected }) => (selected ? '#006ee6' : 'gray')};


  &:hover {
    color: #006ee6;
    transition: 0.2s ease-in-out;
  }
`;


export const StyledIconList = styled(FaList)`
 margin: 14px;
 color:${({ selected }) => (selected ? '#006ee6' : 'gray')};


  &:hover {
    color: #006ee6;
    transition: 0.2s ease-in-out;
  }
`;


export const StyledIconGraph = styled(FaChartBar)`
 margin: 14px;
 color:${({ selected }) => (selected ? '#006ee6' : 'gray')};


  &:hover {
    color: #006ee6;
    transition: 0.2s ease-in-out;
  }
`;

export const TeamWrapper = styled.div`
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: center;
  z-index: 10;
  max-height: 600px;
  margin-top: 8px;

 @media screen and (max-width: 490px){
  }
`;


export const ListRow = styled.div`
  background: linear-gradient(112deg, rgb(35, 36, 40) 0%, #006ee6 120%);
  display: flex;
  margin: 4px 2px;
  border-radius: 12px;
  flex-direction: row;
  align-items: center;
  height: 60px;
  width: 600px;
  padding: 0 12px; /* Adds space inside the edges so items don't hit borders */
  box-sizing: border-box;

  @media screen and (max-width: 430px) {
    height: 55px;
    max-width: 320px;
    padding: 0 8px;
  }
`;

export const ListRowSlot = styled.div`
  background: linear-gradient(112deg, rgb(35, 36, 40) 0%, #6e7174 120%);
  display: flex;
  margin: 4px 2px;
  border-radius: 12px;
  flex-direction: row;
  align-items: center;
  height: 60px;
  width: 600px;
  padding: 0 12px; /* Adds space inside the edges so items don't hit borders */
  box-sizing: border-box;

  @media screen and (max-width: 430px) {
    height: 55px;
    max-width: 320px;
    padding: 0 8px;
  }
`;
// Space out the image from the text stack
export const RowIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px; 
  background: #006ee6;
  width: 44px;
  height: 44px;
  flex-shrink: 0; /* Prevents the image container from squishing */
  margin-right: 12px;

  @media screen and (max-width: 490px){
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }
`;


export const RowH1 = styled.div`
  display: flex;
  align-self: start;
  color: white;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 6px;
  margin-bottom: 5px;
  min-width: 100px;
  justify-content: center;

 @media screen and (max-width: 490px){
    font-size: 10px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
`;

export const Img = styled.img`
  width: 65%; 
  height: 65%;
  object-fit: contain; 
`;

// Crucial: flex-grow expands this box to push the remove button away
export const ColInfoStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1; 
  min-width: 0; /* Allows text truncation safely if names get too long */
`;

// Cleaned up font size hierarchies
export const PlayerName = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: left;

  @media screen and (max-width: 490px){
    font-size: 12px;
  }
`;


// Crucial: flex-grow expands this box to push the remove button away
export const RowInfoStack = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1; 
  max-width: 40%;
  
  @media screen and (max-width: 490px){
     max-width: 80%;
  }
`;

export const PlayerCost = styled.div`
  color: rgba(255, 255, 255, 0.7); /* Slightly muted white for better hierarchy */
  font-size: 11px;
  font-weight: 400;
  margin-top: 2px;
  text-align: left;

  @media screen and (max-width: 490px){
    font-size: 10px;
  }
`;

export const PlayerProjection = styled.div`
  color: rgba(255, 255, 255, 0.7); /* Slightly muted white for better hierarchy */
  font-size: 11px;
  font-weight: 400;
  margin-top: 2px;
  text-align: right;

  @media screen and (max-width: 490px){
    font-size: 10px;
  }
`;

// Anchors nicely on the right side
export const RemoveButton = styled.button`
  margin-left: auto; /* Pushes the button cleanly to the absolute right side */
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;

  &:hover {
    background: #ff4d4d; /* Changes color to red on hover since it's a remove button */
    border-color: transparent;
  }

  @media screen and (max-width: 430px) {
    padding: 4px 8px;
    font-size: 11px;
  }
`;
